import { render, staticRenderFns } from "./CalendarReservationsPlanner.vue?vue&type=template&id=01c45d96"
import script from "./CalendarReservationsPlanner.vue?vue&type=script&lang=js"
export * from "./CalendarReservationsPlanner.vue?vue&type=script&lang=js"
import style0 from "./CalendarReservationsPlanner.vue?vue&type=style&index=0&id=01c45d96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports